'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../types/components/index.js');
var cmsMetadataUtilities = require('./cmsMetadataUtilities.js');

/**
 * Utility to retrieve metadata for all component types.
 */
const getAllComponentsMetadata = () => {
    return cmsMetadataUtilities.getClassesMetadata(index);
};
/**
 * Utility to retrieve metadata for single component.
 */
const getComponentMetadata = (key) => {
    return cmsMetadataUtilities.getClassMetadataByKey(key);
};

exports.getAllComponentsMetadata = getAllComponentsMetadata;
exports.getComponentMetadata = getComponentMetadata;
//# sourceMappingURL=index.js.map
